export default __webpack_public_path__ + "static/recipes-01-img-5e4a54c2b10ccf4574d61b4167421a01.png";